<div *ngIf="errors && errors.length" data-test-id="errorNotif" class="animated fadeIn bot-0100">
  <div class="notif notif--small notif--orange vert-0025"  *ngFor="let error of errors">
    <strong>Oops! </strong>
    <span>{{error}}</span>
  </div>
</div>
